import Tr from 'translations/Translations';
import reduxStore from 'redux/store'
import { setOpenTutorial, setOpenRegisterPopup } from 'redux/actions'
import RouterPath from 'libs/RouterPath';

const createItem = (trKey, action, disabled = true) => ({ label: Tr(trKey), action, disabled })

export default [
	createItem('tutorial', () => {
		reduxStore.dispatch(setOpenTutorial())
	}),
	createItem('faq', () => {
		RouterPath.redirect(RouterPath.FAQ)
	}),
	createItem('contact', () => {
		reduxStore.dispatch(setOpenRegisterPopup(true))
	},
		false
	),
]